export enum NotificationsEntities {
  ENTRY = "ENTRY",
  ORPHAN_TASK = "ORPHAN_TASK",
  LEAD_TASK = "LEAD_TASK",
  CONTACT_TASK = "CONTACT_TASK",
  KANBAN_TASK = "KANBAN_TASK",
  FORM = "FORM",
}
